export default "__VITE_ASSET__DPX3HkO3__"